enum OrgAndIntroducerAndAdvisorFilterType {
  multiselect
}

type OrgAndIntroducerAndAdvisorFilterOption {
  count: Int
  default: Boolean
  display: String
  value: String
}

type OrgAndIntroducerAndAdvisorFilterSchema {
  display_name: String
  param_name: String
  relationship_type: RelationshipType
  type: OrgAndIntroducerAndAdvisorFilterType
  values: [OrgAndIntroducerAndAdvisorFilterOption]
}

type OrgAndIntroducerAndAdvisorFilter {
  filters: [OrgAndIntroducerAndAdvisorFilterSchema]
}
